import App from './views/App.vue';
import Groups from './views/Groups/Index.vue';
import Group from './views/Group/Index.vue';

export default [
  {
    path: '/',
    name: 'app',
    component: App,
    redirect: '/groups',
    children: [
      {
        path: '/groups',
        name: 'groups',
        component: Groups,
        meta: {
          title: '组管理'
        }
      },
      {
        path: '/groups/:code',
        name: 'group',
        component: Group,
        meta: {
          title: '组设置'
        }
      }
    ]
  }
];
